import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { ExistingOptionDefaultUpdate_EditPage_Mutation } from "./mutation";
import { viewModelToOptionInputConverter } from "../../_common/view-model-to-option-input";

import type { ProductOptionFormModel } from "../../../type";

type Props = {
	resetForm: () => void;
};

export const useOptionEditMutation = ({ resetForm }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(ExistingOptionDefaultUpdate_EditPage_Mutation);

	const onUpdate = useCallback(
		async (
			planViewModel: ProductOptionFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToOptionInputConverter({ viewModel: planViewModel });

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "オプションを更新しました",
				});

				resetForm();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, resetForm, showLoadingScreenCallback],
	);

	return { onUpdate };
};
